import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import config from '@/config';
import { getAccessToken, setAccessToken } from '@/shared/services/accessToken';

let pendingToken: Promise<string> | undefined;

const requestToken = async (): Promise<string> => {
	if (!config.junior_oauth_auth_url || !config.junior_oauth_client_id) {
		throw new Error('Junior OAuth config is incomplete');
	}
	const response = await axios.get(config.junior_oauth_auth_url, {
		params: {
			client_id: config.junior_oauth_client_id,
			response_type: config.junior_oauth_response_type,
		},
		withCredentials: true,
	});
	const { access_token, expires_in } = response.data ?? {};
	if (typeof access_token !== 'string' || !access_token) {
		throw new Error('No access token returned from Junior auth server');
	}
	setAccessToken(access_token, typeof expires_in === 'number' ? expires_in : undefined);
	return access_token;
};

export const processJuniorRequest = async (request: AxiosRequestConfig): Promise<AxiosResponse> => {
	if (!config.junior_api_url) throw new Error('Junior API URL is missing');
	const baseUrl = new URL(config.junior_api_url);
	const url = new URL(request.url || '', baseUrl);
	if (url.origin !== baseUrl.origin || !['https:', 'http:'].includes(url.protocol)) {
		throw new Error('Junior request must target the configured API');
	}

	let token = getAccessToken();
	if (!token) {
		pendingToken ??= requestToken().finally(() => {
			pendingToken = undefined;
		});
		token = await pendingToken;
	}
	return axios({
		...request,
		url: url.href,
		headers: { ...request.headers, Authorization: `Bearer ${token}` },
		withCredentials: false,
	});
};
